import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import {
  add_expense_category,
  update_expense_category,
} from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchProcessManagerData } from "../../redux/hygiene-reducers/hygieneSlice";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.catName) {
    errors.catName = "Category Name Required!";
  }

  if (!formValues.selectedProcessManager) {
    errors.selectedProcessManager = "Process Manager Required!";
  }

  if (!formValues.description) {
    errors.description = "Category Description Is Required!";
  }

  // if (formValues.isPettyCash === undefined || formValues.isPettyCash === null) {
  //   errors.isPettyCash = "Petty Cash selection is required!";
  // }

  // if (
  //   formValues.isGymExpense === undefined ||
  //   formValues.isGymExpense === null
  // ) {
  //   errors.isGymExpense = "Gym Expense selection is required!";
  // }

  return errors;
};

const ExpenseCatForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { processManagerData } = useSelector((state) => state.hygiene);
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);

  const [allExpenseManagers, setAllExpenseManagers] = useState([]);
  const forminitials = {
    catName: isEdit && rowData?.name ? rowData.name : "",
    selectedProcessManager:
      isEdit && rowData?.approval_manager_id
        ? {
            value: rowData?.approval_manager_id || "",
            label: rowData?.approval_manager_name || "",
          }
        : "",
    description: isEdit && rowData?.description ? rowData.description : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
    isPettyCash: isEdit ? (rowData?.is_petty_cash === 1 ? true : false) : false,
    isGymExpense: isEdit
      ? rowData?.is_gym_expense === 1
        ? true
        : false
      : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  function getProcessExpenseCategories() {
    const payload = {
      filters: {
        page: 1,
        limit: 1000,
        status: "active",
        role_type: "approval_manager",
      },
      token: userInfoData?.token,
    };
    dispatch(fetchProcessManagerData(payload));
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_expense_category : add_expense_category;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getProcessExpenseCategories();
  }, []);

  useEffect(() => {
    if (processManagerData?.status && processManagerData?.data?.length > 0) {
      const allCats = processManagerData.data?.map((item) => ({
        value: item.user_id,
        label: item.user_name,
        info: item,
      }));

      setAllExpenseManagers(allCats);
    } else {
      setAllExpenseManagers([]);
    }
  }, [processManagerData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.catName || "",
        approval_manager_id: formValues.selectedProcessManager?.value || "",
        description: formValues.description || "",
        status: formValues.isActive ? "active" : "inactive",
        is_petty_cash: formValues.isPettyCash ? 1 : 0,
        is_gym_expense: formValues.isGymExpense ? 1 : 0,
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Category`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="catName" className={`formInputLabel `}>
              expense category name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Category Name"
              className={`formInput ${formErrors?.catName ? "formError" : ""}`}
              name="catName"
              value={formValues.catName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedProcessManager" className="formInputLabel">
              expense process manager <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedProcessManager ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={allExpenseManagers}
                selectedOption={formValues.selectedProcessManager}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedProcessManager")
                }
                name="Process Manager"
              />
            </div>
          </div>

          <div className="formInputBox gridSpanFour">
            <label htmlFor="description" className="formInputLabel">
              expense category description <span className="required">*</span>
            </label>

            <textarea
              name="description"
              className={`formInput ${
                formErrors?.description ? "formError" : ""
              }`}
              placeholder="Enter Category Description"
              value={formValues.description}
              onChange={onChangeInput}
            ></textarea>
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isPettyCash ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isPettyCash"
              label={`Petty Cash`}
              checked={formValues.isPettyCash}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isGymExpense ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isGymExpense"
              label={`Gym Expense`}
              checked={formValues.isGymExpense}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ExpenseCatForm;
